<script setup lang="ts">
    import { commandGroupKey, useCommandContext } from './context';

    defineProps<{
        /** The heading, which names the group */
        heading?: string;
    }>();

    const slots = defineSlots<{
        default(): unknown;
        /** Replaces the `heading` text */
        heading?(): unknown;
    }>();

    const context = useCommandContext('CommandGroup');
    const group = Symbol('CommandGroup');
    provide(commandGroupKey, group);

    const headingId = useId();
</script>

<template>
    <!-- Hidden, not removed, while the search finds none of its items: the items stay registered -->
    <div
        role="group"
        data-slot="command-group"
        class="ui-command-group"
        :hidden="!context.isGroupVisible(group)"
        :aria-labelledby="heading || slots.heading ? headingId : undefined"
    >
        <div
            v-if="heading || slots.heading"
            :id="headingId"
            data-slot="command-group-heading"
            class="ui-command-group__heading"
        >
            <slot name="heading">{{ heading }}</slot>
        </div>
        <slot />
    </div>
</template>

<style scoped>
    @layer components {
        .ui-command-group[hidden] {
            display: none;
        }

        .ui-command-group__heading {
            padding: 8px 12px 4px;
            color: var(--color-muted-foreground);
            font-size: var(--text-xs);
            font-weight: var(--font-weight-medium);
            line-height: var(--text-xs--line-height);
            cursor: default;
            user-select: none;
        }
    }
</style>
